"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmrDropdown = exports.onKeyDown = exports.handleOutsideClick = exports.handleOnSelect = exports.toggleActiveHeader = void 0;
// packages
const react_1 = __importStar(require("react"));
// styles
const Dropdown_styles_1 = require("./Dropdown.styles");
const DropdownTypes_1 = require("./DropdownTypes");
// components
const DropdownHeader_1 = __importDefault(require("./DropdownHeader"));
const DropdownItem_1 = __importDefault(require("./DropdownItem"));
const DropdownTitle_1 = __importDefault(require("./DropdownTitle"));
const toggleActiveHeader = (isActive, setIsActive) => setIsActive(!isActive);
exports.toggleActiveHeader = toggleActiveHeader;
const handleOnSelect = (onSetHeaderValue, onSelect, option) => {
    onSetHeaderValue(option);
    onSelect(option);
};
exports.handleOnSelect = handleOnSelect;
const regexForAlphanumeric = new RegExp(/[a-z0-9]/i);
const handleOutsideClick = (event, isActive, selectedOption, setIsActive) => {
    var _a;
    const element = event.target;
    if (isActive && !((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.current) === null || _a === void 0 ? void 0 : _a.includes(element))) {
        setIsActive(false);
    }
};
exports.handleOutsideClick = handleOutsideClick;
const onKeyDown = (e, options, isActive, callback, searchParam) => {
    const conditionToHover = (condition, i) => condition ? Object.assign(Object.assign({}, i), { isHovered: true }) : Object.assign(Object.assign({}, i), { isHovered: false });
    const indexOfSelctedItem = options === null || options === void 0 ? void 0 : options.findIndex((option) => option.isHovered);
    e.preventDefault();
    if (e.nativeEvent.code !== DropdownTypes_1.keyAllowed.UP &&
        e.nativeEvent.code !== DropdownTypes_1.keyAllowed.DOWN &&
        e.nativeEvent.code !== DropdownTypes_1.keyAllowed.ENTER &&
        e.nativeEvent.code !== DropdownTypes_1.keyAllowed.ENTER_NUMPAD &&
        searchParam) {
        let indexOfTypeItem = options.findIndex((i) => {
            var _a;
            return (_a = i.secondColumn) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().substring(0, 3).includes(searchParam.substring(0, 3));
        });
        if (indexOfTypeItem === -1) {
            indexOfTypeItem = options.findIndex((i) => {
                var _a;
                return (_a = i.firstColumn) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().substring(0, 3).includes(searchParam.substring(0, 3));
            });
        }
        if (indexOfTypeItem >= 0) {
            return options.map((i, index) => conditionToHover(index === indexOfTypeItem, i));
        }
    }
    else if (indexOfSelctedItem === -1 &&
        e.nativeEvent.code != DropdownTypes_1.keyAllowed.ENTER &&
        e.nativeEvent.code !== DropdownTypes_1.keyAllowed.ENTER_NUMPAD) {
        return options.map((i, index) => conditionToHover(index === 0, i));
    }
    let newOptions = [...options];
    switch (true) {
        case e.nativeEvent.code === DropdownTypes_1.keyAllowed.DOWN:
            if (indexOfSelctedItem === options.length - 1 &&
                e.nativeEvent.code === DropdownTypes_1.keyAllowed.DOWN) {
                newOptions = options.map((i, index) => conditionToHover(index === 0, i));
            }
            else {
                newOptions = options.map((i, index) => conditionToHover(index === indexOfSelctedItem + 1, i));
            }
            break;
        case e.nativeEvent.code === DropdownTypes_1.keyAllowed.UP:
            if (indexOfSelctedItem === 0) {
                newOptions = options.map((i, index) => conditionToHover(index === options.length - 1, i));
            }
            else {
                newOptions = options.map((i, index) => conditionToHover(index === indexOfSelctedItem - 1, i));
            }
            break;
        case e.nativeEvent.code === DropdownTypes_1.keyAllowed.ENTER:
            newOptions = getDefaultHoveredOptions(options);
            if (isActive) {
                callback(indexOfSelctedItem);
            }
            break;
        default:
            break;
    }
    return newOptions;
};
exports.onKeyDown = onKeyDown;
const defaultFormat = (option, numberOfColumns = 3) => {
    return numberOfColumns
        ? Object.keys(option)
            .slice(0, numberOfColumns)
            .reduce((value, currentValue) => {
            return value + ' ' + Reflect.get(option, currentValue);
        }, '')
        : `${option.firstColumn} - ${option.secondColumn} (MC # ${option.thirdColumn})`;
};
const getDefaultHoveredOptions = (array) => array.map((i) => (Object.assign(Object.assign({}, i), { isHovered: false })));
const SmrDropdown = (props) => {
    const containerRef = (0, react_1.useRef)(null);
    const [options, setOptions] = (0, react_1.useState)(getDefaultHoveredOptions(props.options || []));
    const [isActive, setIsActive] = (0, react_1.useState)(false);
    const [searchParam, setSearchParam] = (0, react_1.useState)('');
    const [headerValue, setHeaderValue] = (0, react_1.useState)('');
    const selectedOption = (0, react_1.useRef)(null);
    const scrollableRef = (0, react_1.useRef)(null);
    const hoverIndex = options.findIndex((option) => option.isHovered);
    const format = (0, react_1.useMemo)(() => {
        return props.format ? props.format : defaultFormat;
    }, [props.format]);
    (0, react_1.useEffect)(() => {
        const isScrollable = (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) &&
            scrollableRef.current.scrollHeight > scrollableRef.current.clientHeight;
        if (isScrollable) {
            // Ensure Hovered item is scrolled into view.
            if (hoverIndex + 1 > props.maxOptionRender) {
                const visibleArea = props.maxOptionRender * 48;
                const indexTopOffset = hoverIndex * 48;
                const scrollAmount = indexTopOffset > visibleArea - 100 ? indexTopOffset : 0;
                scrollableRef.current.scrollTo(0, scrollAmount - (visibleArea - 100));
            }
            else {
                scrollableRef.current.scrollTo(0, 0);
            }
        }
    }, [hoverIndex]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!props.options) {
            setHeaderValue(props.disabledText);
            return;
        }
        const firstOption = props.options[0];
        onSetHeaderValue((_a = props === null || props === void 0 ? void 0 : props.currentSelectedOption) !== null && _a !== void 0 ? _a : firstOption);
    }, []);
    const onSetHeaderValue = (0, react_1.useCallback)((option) => {
        var _a;
        setHeaderValue(format(option, ((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.numberOfColumns) || 3));
    }, [format]);
    (0, react_1.useEffect)(() => {
        const listener = (e) => {
            (0, exports.handleOutsideClick)(e, isActive, selectedOption, setIsActive);
            setOptions(getDefaultHoveredOptions(options));
        };
        document.addEventListener('click', listener);
        return () => {
            document.removeEventListener('click', listener);
        };
    }, [isActive]);
    const isSelectedOption = (0, react_1.useCallback)((option) => {
        return headerValue === format(option);
    }, [format, headerValue]);
    const handleOnKeyDown = (e) => {
        e.persist();
        const selectCallback = (indexOfSelctedItem) => {
            (0, exports.toggleActiveHeader)(isActive, setIsActive);
            (0, exports.handleOnSelect)(onSetHeaderValue, props.onSelect, options[indexOfSelctedItem]);
            setSearchParam('');
        };
        let newOptions = options;
        if (e.nativeEvent.code === DropdownTypes_1.keyAllowed.DOWN ||
            e.nativeEvent.code === DropdownTypes_1.keyAllowed.UP ||
            e.nativeEvent.code === DropdownTypes_1.keyAllowed.ENTER ||
            e.nativeEvent.code === DropdownTypes_1.keyAllowed.ENTER_NUMPAD) {
            newOptions = (0, exports.onKeyDown)(e, options, isActive, selectCallback);
            setOptions(newOptions);
            return;
        }
        if (regexForAlphanumeric.test(e.key)) {
            setSearchParam((prev) => {
                return prev + e.key;
            });
            newOptions = (0, exports.onKeyDown)(e, options, isActive, selectCallback, searchParam + e.key);
        }
        setOptions(newOptions);
    };
    if (!props.options) {
        return (react_1.default.createElement(Dropdown_styles_1.StyledDropdownContainer, null,
            react_1.default.createElement(DropdownHeader_1.default, { disabled: true, value: headerValue })));
    }
    return (react_1.default.createElement(Dropdown_styles_1.StyledDropdownContainer, { tabIndex: 0, "data-testid": "dropdown", ref: containerRef, onKeyDownCapture: handleOnKeyDown },
        react_1.default.createElement(DropdownHeader_1.default, { "data-testid": "dropdown-header", disabled: false, isActive: isActive, onClick: () => {
                var _a;
                (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                (0, exports.toggleActiveHeader)(isActive, setIsActive);
                setSearchParam('');
            }, value: headerValue }),
        isActive ? (react_1.default.createElement(Dropdown_styles_1.StyledDropdownListContainer, { ref: scrollableRef, maxOptions: props.maxOptionRender, totalOptions: props.options.length, hasTitle: true }, options && (react_1.default.createElement(Dropdown_styles_1.StyledDropdownList, { id: "list" },
            props.hasTitle && props.titleItem && (react_1.default.createElement(DropdownTitle_1.default, { config: props.config, title: props.titleItem })),
            options.map((option) => (react_1.default.createElement(DropdownItem_1.default, { onClick: () => (0, exports.handleOnSelect)(onSetHeaderValue, props.onSelect, option), config: props.config, option: option, isSelected: isSelectedOption(option), isHovered: Boolean(option.isHovered), key: option.firstColumn, format: format }))))))) : (react_1.default.createElement(Dropdown_styles_1.StyledDropdownDefaultText, null, props.defaultText))));
};
exports.SmrDropdown = SmrDropdown;
exports.default = exports.SmrDropdown;
//# sourceMappingURL=Dropdown.js.map